import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

import { SiGooglemaps } from "react-icons/si";
import { FaPhoneAlt, FaFacebook, FaYoutube, FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const API = "https://labwayscientific.com/backend/wp-json/wc/v3";
const CK = "ck_e1c36267e6a5e3cb0198558262bf2096181b4a0b";
const CS = "cs_fc900ba31d63fade2cfba415abe8a599366c20b0";

function Footer() {

  const [categories, setCategories] = useState([]);

  useEffect(() => {
  fetch(`${API}/products/categories?per_page=50&consumer_key=${CK}&consumer_secret=${CS}`)
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) {

        // 🔥 ONLY PARENT CATEGORIES
        const parentCats = data.filter(cat => cat.parent === 0);

        setCategories(parentCats);

      } else {
        console.error("Category error:", data);
        setCategories([]);
      }
    });
}, []);

  return (
    <footer>
      <section className="footer-main">
        <div className="container">

          <div className="row">

            {/* QUICK LINKS */}
            <div className='foot-01 col-md-3'>
              <h3>Quick Links</h3>
              <ul className='foot-menu'>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                {/* <li><Link to="/gallery">Gallery</Link></li> */}
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>

            {/* 🔥 OUR PRODUCTS (DYNAMIC) */}
            <div className='foot-02 col-md-6'>
              <h3>Our Products</h3>
              <ul className='foot-menu'>

                {Array.isArray(categories) && categories.map(cat => (
                  <li key={cat.id}>
                    <Link to={`/category/${cat.id}`}>
                      {cat.name}
                    </Link>
                  </li>
                ))}

              </ul>
            </div>

            {/* ADDRESS */}
            <div className='foot-03 foot-address col-md-3'>
              <h3>Keep In Touch</h3>
              <ul className='foot-menu'>
                <li><SiGooglemaps />#16/6/13 Kunj Vihar, River Side, AMBALA CANTT (INDIA).</li>
                <li><FaPhoneAlt /> 
                  <a href="tel:+91-92066-91066">+91-92066-91066</a>, 
                  <a href="tel:+91-98967-85189">+91-98967-85189</a>
                </li>
                <li><MdEmail /> 
                  <a href="mailto:info@labwayscientific.com">info@labwayscientific.com</a>
                </li>
              </ul>
            </div>

            {/* SOCIAL */}
            {/* <div className='foot-04 col-md-3'>
              <h3>Follow Us</h3>
              <ul className='social-menu'>
                <li><a href="#"><FaFacebook /> Facebook</a></li>
                <li><a href="#"><FaYoutube /> Youtube</a></li>
                <li><a href="#"><FaInstagram /> Instagram</a></li>
              </ul>
            </div> */}

          </div>
        </div>
      </section>
      <section class="footer-copyright">
               <div class="container">
                  <div class="row text-center">
                     <div class="col">
                        <p>© Copyright 2026 Labway Scientific System. All Rights Reserved</p>
                     </div>
                  </div>
               </div>
            </section>
    </footer>
  );
}

export default Footer;